import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
      userId: null,
    };
  },
  async get() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Categories`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getFromKey(key) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Categories/Key/${key}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
};
